// extracted by mini-css-extract-plugin
export default {"body":"Layout_body__AOzHb","navHeader":"Layout_navHeader__+Dl88"};